import { render, staticRenderFns } from "./ProjectInfo.vue?vue&type=template&id=3837d906&scoped=true&"
import script from "./ProjectInfo.vue?vue&type=script&lang=js&"
export * from "./ProjectInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInfo.vue?vue&type=style&index=0&id=3837d906&prod&lang=css&"
import style1 from "./ProjectInfo.vue?vue&type=style&index=1&id=3837d906&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3837d906",
  null
  
)

export default component.exports